import { createAction, props } from '@ngrx/store';
import { AppointmentRequestQuery } from '@warema/shared/models';

export const SetAppointmentRequestQuery = createAction(
    '[AppointmentMetadata] SetAppointmentRequestQuery',
    props<{ appointmentRequestQuery: AppointmentRequestQuery }>(),
);
